import { NavLink } from "react-router-dom";
import { LayoutGrid, ShoppingCart, Truck, Package, MoreHorizontal } from "lucide-react";
import { useBadges } from "@/hooks/useBadges";

// BottomNav — 5 raccourcis mobile. Le bouton "Plus" ouvre le drawer via prop `onOpenMore`.
const items = [
  { to: "/",            label: "Accueil",     icon: LayoutGrid,   end: true },
  { to: "/ventes",      label: "Ventes",      icon: ShoppingCart, end: false },
  { to: "/livraisons",  label: "Livraisons",  icon: Truck,        end: false },
  { to: "/stock",       label: "Stock",       icon: Package,      end: false },
];

const BottomNav = ({ onOpenMore, moreActive }) => {
  const badges = useBadges();
  return (
    <nav
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-[0_-2px_10px_rgba(0,0,0,0.04)] ${moreActive ? "hidden" : ""}`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="admin-bottom-nav"
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition ${isActive ? "text-indigo-600" : "text-slate-500 hover:text-slate-700"}`
            }
            data-testid={`bottom-nav-${label.toLowerCase()}`}
          >
            <Icon className="w-5 h-5" />
            <span>{label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onOpenMore}
          className={`relative flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition ${moreActive ? "text-indigo-600" : "text-slate-500 hover:text-slate-700"}`}
          data-testid="bottom-nav-plus"
          aria-label="Plus de modules"
        >
          <MoreHorizontal className="w-5 h-5" />
          <span>Plus</span>
          {badges.communications > 0 && (
            <span className="absolute top-1 right-4 bg-red-500 text-white text-[9px] font-bold px-1 py-0 rounded-full min-w-[16px] leading-4 text-center" data-testid="bottom-nav-plus-badge">
              {badges.communications}
            </span>
          )}
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
